import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'password-error-footer',
  templateUrl: './password-error-footer.component.html'
})
export class PasswordErrorFooterComponent {

  @Input() form: FormGroup;

  constructor() {
  }

}
